<template>
  <div>
    this is only a placeholder for the dashboard page
  </div>
</template>
